// React Component (or JSX)

import React from 'react';
import './App.css'; // Assuming you have a CSS file for styles

const Krasserm_fsdl_text_recognizer_2021_labs_From_2021_3_01_To_2021_3_31 = () => {
  return (
    <>
     <a
        href="https://github.com/krasserm?tab=overview&from=2021-03-01&to=2021-03-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from Apr 1, 2025 to Apr 30, 2025
      </a>
<div>
<a
        href="https://github.com/krasserm?tab=overview&from=2021-04-01&to=2021-04-30"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/krasserm?tab=overview&from=2021-04-01&to=2021-04-30
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
><div 
className="flex-auto min-width-0 width-fit">
              <div id="repo-title-component" 
              className=" d-flex flex-nowrap flex-items-center wb-break-word f3 text-normal">
    <img className="avatar mr-2 d-none d-md-block avatar-user" alt="Owner avatar" src="https://avatars.githubusercontent.com/u/202907?s=48&amp;v=4" width="24" height="24"></img>
  

  <strong 
  // itemprop="name" 
  className="mr-2 flex-self-stretch d-none d-md-block no-wrap overflow-x-hidden">
    <a data-pjax="#repo-content-pjax-container" data-turbo-frame="repo-content-turbo-frame" className="d-block overflow-x-hidden color-fg-default" style={{'textOverflow': 'ellipsis'}} href="https://github.com/krasserm/fsdl-text-recognizer-2021-labs">fsdl-text-recognizer-2021-labs</a>
  </strong>

  <span></span><span className="Label Label--secondary v-align-middle mr-1 d-none d-md-block">Public</span>
</div>

<div className="d-none d-md-block">
    <span className="text-small lh-condensed-ultra no-wrap mt-1" data-repository-hovercards-enabled="">
      forked from <a data-hovercard-type="repository" data-hovercard-url="/the-full-stack/fsdl-text-recognizer-2021-labs/hovercard" className="Link--inTextBlock" href="https://github.com/the-full-stack/fsdl-text-recognizer-2021-labs">https://github.com/the-full-stack/fsdl-text-recognizer-2021-labs</a>
    </span>
</div>
</div>
  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/krasserm/fsdl-text-recognizer-2021-labs" target="_blank" rel="noopener noreferrer">
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/krasserm" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">krasserm</a>

{/* <div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/EnzymeAD/Reactant.jl/pull/55" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Aug 5, 2024</relative-time></a>


  </div> */}
</div>

<p>Here are the details of the fork of this <a href="https://github.com/krasserm/fsdl-text-recognizer-2021-labs" target="_blank">fsdl-text-recognizer-2021-labs repository</a>:</p>
 {/* <a data-pjax="#repo-content-pjax-container" data-turbo-frame="repo-content-turbo-frame" class="d-block overflow-x-hidden color-fg-default"  */}
 {/* style="text-overflow: ellipsis;" href="/krasserm/fsdl-text-recognizer-2021-labs">fsdl-text-recognizer-2021-labs</a> */}
<a
  href="/krasserm/fsdl-text-recognizer-2021-labs"
  style={{
    display: 'block',
    overflowX: 'hidden',
    color: '#000', // Fallback color
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    whiteSpace: 'nowrap', // To ensure ellipsis works correctly
  }}
  title="fsdl-text-recognizer-2021-labs" // Tooltip for full text on hover
>
  fsdl-text-recognizer-2021-labs
</a>

<div 
className="flex-auto min-width-0 width-fit">
              <div id="repo-title-component" 
              className=" d-flex flex-nowrap flex-items-center wb-break-word f3 text-normal">
    <img className="avatar mr-2 d-none d-md-block avatar-user" alt="Owner avatar" src="https://avatars.githubusercontent.com/u/202907?s=48&amp;v=4" width="24" height="24"></img>
  

  <strong 
  // itemprop="name" 
  className="mr-2 flex-self-stretch d-none d-md-block no-wrap overflow-x-hidden">
    <a data-pjax="#repo-content-pjax-container" data-turbo-frame="repo-content-turbo-frame" className="d-block overflow-x-hidden color-fg-default" style={{'textOverflow': 'ellipsis'}} href="https://github.com/krasserm/fsdl-text-recognizer-2021-labs">fsdl-text-recognizer-2021-labs</a>
  </strong>

  <span></span><span className="Label Label--secondary v-align-middle mr-1 d-none d-md-block">Public</span>
</div>

<div className="d-none d-md-block">
    <span className="text-small lh-condensed-ultra no-wrap mt-1" data-repository-hovercards-enabled="">
      forked from <a data-hovercard-type="repository" data-hovercard-url="/the-full-stack/fsdl-text-recognizer-2021-labs/hovercard" className="Link--inTextBlock" href="https://github.com/the-full-stack/fsdl-text-recognizer-2021-labs">https://github.com/the-full-stack/fsdl-text-recognizer-2021-labs</a>
    </span>
</div>


        </div>
        
    </>
  );
};

export default Krasserm_fsdl_text_recognizer_2021_labs_From_2021_3_01_To_2021_3_31;
